import $ from 'jquery';
import PayLaterBaseMessage from "./PayLaterBaseMessage";

class PayLaterProductMessage extends PayLaterBaseMessage {

    constructor(props) {
        super(props);
        this.product = props.product;
    }

    initialize() {
        this.actions.addAction('quantity_change', this.onQuantityChange.bind(this));
        this.actions.addAction('found_variation', this.onFoundVariation.bind(this));
        this.actions.addAction('reset_variation', this.onResetVariation.bind(this));
        super.initialize();
    }

    onQuantityChange(qty) {
        this.createMessage();
    }

    onFoundVariation(changed) {
        this.createMessage();
    }

    onResetVariation(product) {
        this.createMessage();
    }

    getMessageContainer() {
        const el = document.getElementById('wc-ppcp-paylater-msg-product');
        if (!el) {
            $('form.checkout .shop_table').after('<div id="wc-ppcp-paylater-msg-product"></div>');
        }
        return document.getElementById('wc-ppcp-paylater-msg-product');
    }

    getTotal() {
        return this.product.getTotal();
    }

    getPlacement() {
        return 'product';
    }
}

export default PayLaterProductMessage;
export {PayLaterProductMessage};